import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const fineMouse = () => window.matchMedia("(pointer: fine)").matches;

export default function Interactive3D() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (!fineMouse()) return;
    let current = null;
    const reset = (el) => el && (el.style.transform = "");
    const onMove = (e) => {
      const el = e.target.closest?.(".card-lift");
      if (el !== current) { reset(current); current = el; }
      if (!el) return;
      const r = el.getBoundingClientRect();
      const x = (e.clientX - r.left) / r.width - 0.5;
      const y = (e.clientY - r.top) / r.height - 0.5;
      el.style.transform = `perspective(900px) rotateX(${(-y * 10).toFixed(2)}deg) rotateY(${(x * 12).toFixed(2)}deg) translateY(-8px) scale(1.015)`;
    };
    const onLeave = () => { reset(current); current = null; };
    document.addEventListener("pointermove", onMove);
    document.addEventListener("pointerleave", onLeave);
    return () => {
      document.removeEventListener("pointermove", onMove);
      document.removeEventListener("pointerleave", onLeave);
    };
  }, []);

  useEffect(() => {
    const io = new IntersectionObserver(
      (entries) => entries.forEach((en) => {
        if (en.isIntersecting || en.boundingClientRect.top < 0) { en.target.classList.add("r3d-in"); io.unobserve(en.target); }
      }),
      { threshold: 0, rootMargin: "0px 0px -60px 0px" }
    );
    const seen = new WeakSet();
    const scan = () => document.querySelectorAll("main section:not(.r3d-in)").forEach((s) => {
      if (seen.has(s)) return;
      seen.add(s);
      s.classList.add("r3d");
      io.observe(s);
    });
    scan();
    const main = document.querySelector("main");
    const mo = new MutationObserver(scan);
    if (main) mo.observe(main, { childList: true, subtree: true });
    return () => { io.disconnect(); mo.disconnect(); };
  }, [pathname]);

  return null;
}
